/* eslint-disable no-unused-vars */

import api from '@utils/api'

import {
  StatusRestringido
} from '@constants/general'

export const getTypeUsers = () => async (_dispatch, _getState) => {
  const response = await api.getTypeUsers()
  return response
}

export const updateRestringir = ({ id, restringido }) => async (_dispatch, _getState) => {
  let validateRestriccion = null
  if (restringido === StatusRestringido.IS_RESTRINGIDO) validateRestriccion = StatusRestringido.NOT_RESTRINGIDO
  if (restringido === StatusRestringido.NOT_RESTRINGIDO) validateRestriccion = StatusRestringido.IS_RESTRINGIDO
  const data = {
    isRestringido: validateRestriccion,
  }
  const response = await api.updateRestringir(id, data)
  return response;
};

export const getSectionsLocked = (typeUser) => async (_dispatch, _getState) => {
  const response = await api.getSectionsLocked(typeUser)
  return response
}

export const updateSectionsLocked = ({ typeUser, sectionsLocked }) => async (_dispatch, _getState) => {
  const data = sectionsLocked.map(item => ({seccion: item}))
  const response = await api.updateSectionsLocked(typeUser, data)
  return response;
};